import { Button } from "@component-ui/utility/Button";
import Empty from "@component-ui/Empty";
import LoadingSpinnerCenter from "@component-ui/LoadingSpinnerCenter";
import { useDocumentTemplatesQuery } from "@hooks/template/useDocumentTemplatesQuery";
import { FileType } from "lucide-react";
import { useState } from "react";
import DocumentTemplateRow from "./DocumentTemplateRow";
import CustomerTagComboBox from "@component-func/customer-tag/CustomerTagComboBox";
import { SEARCH_PARAMS } from "@constant/searchParams";
import { useParams, useSearchParams } from "react-router-dom";
import CreateDocumentTemplateDialog from "./CreateDocumentTemplateDialog";

export default function DocumentTemplateList() {
    const [search] = useSearchParams();
    const { documentTemplateId } = useParams();
    const [selectedTagId, setSelectedTagId] = useState(
        search.get(SEARCH_PARAMS.CURRENT_TAG) || "",
    );
    const {
        data: templates,
        isFetching,
        isLoading,
        isError,
        isSuccess,
        refetch,
    } = useDocumentTemplatesQuery(selectedTagId);

    if (isLoading) {
        return <LoadingSpinnerCenter />;
    }

    if (!isSuccess || isError) {
        return (
            <div className="h-full grid place-items-center">
                <Button onClick={() => refetch()}>Retry</Button>
            </div>
        );
    }
    return (
        <aside className="h-full w-full grid grid-rows-[max-content,max-content,1fr,max-content] gap-2 p-2">
            <span className="inline-flex items-center gap-2">
                <FileType className="min-w-[40px] w-10 h-10" />
                <h1 className="text-2xl font-medium leading-none">Templates</h1>
            </span>
            <CustomerTagComboBox
                selectedTagId={selectedTagId}
                setSelectedTagId={setSelectedTagId}
            />
            {isFetching ? (
                <LoadingSpinnerCenter />
            ) : (
                <ul className="h-full overflow-auto">
                    {templates.length <= 0 ? (
                        <Empty label="Do not have template yet, create a new template to start" />
                    ) : (
                        templates.map((template) => (
                            <li key={template.id}>
                                <DocumentTemplateRow
                                    {...template}
                                    currentDocumentTemplateId={
                                        documentTemplateId || ""
                                    }
                                />
                            </li>
                        ))
                    )}
                </ul>
            )}
            <CreateDocumentTemplateDialog />
        </aside>
    );
}
